// Shared HH:MM:SS <-> seconds helpers for the episode admin pages.
// formatSeconds also lives on CompactYouTubePlayer.js (re-exported from
// there for backwards compat) — this is the canonical source.

export function formatSeconds(sec) {
  if (sec == null || sec === "" || isNaN(sec)) return "";
  sec = Math.floor(Number(sec));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function timeToSec(t) {
  if (!t || typeof t !== "string") return null;
  const parts = t.split(":").map(Number);
  if (parts.some(isNaN)) return null;
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  if (parts.length === 1) return parts[0];
  return null;
}

export const secToHMS = formatSeconds;
